export default "__VITE_ASSET__uCnVZx5B__"